exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-fd7084ce]{margin:0}ul .note-item[data-v-fd7084ce]{border-top:1px solid #ccc;border-bottom:1px solid #999}div.notebook-body[data-v-fd7084ce]{position:relative;height:calc(100% - 50px);padding:0;margin:0;overflow:auto}header.main[data-v-fd7084ce]{position:relative;z-index:999}header.main .menu-button[data-v-fd7084ce]{position:absolute;top:0;right:0;height:50px;width:50px}.notebook-message[data-v-fd7084ce]{margin:20px}@media only screen and (min-device-width:320px) and (max-device-width:480px){ul.notebook[data-v-fd7084ce]{height:calc(100% - 50px)}}", ""]);

// exports
